import { useState } from 'react';
import "../../assets/css/project.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHammer, faCog, faGlobe } from '@fortawesome/free-solid-svg-icons';
import Skills from "../../components/skills";


const Projects = () => {
  
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTechnologies, setModalTechnologies] = useState([]);

  const openModal = (languages) => {
    setModalTechnologies(languages);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalTechnologies([]);
  };

  const projects = [
    {
      title: "Listurls",
      description: "Este projeto visa oferecer aos usuários uma plataforma para armazenar seus links favoritos de forma organizada em listas, e torná-los acessíveis online.",
      languages: ["React", ".NET8", "Python", "MongoDB", "PostgreSQL", "Docker", "Kubernetes", "Oauth2 Google", "SendGrid", "ELK Stack"],
      link: "https://listurls.zauso-dev.com.br/",
      deploy: true,
    },
    // {
    //   title: "ZausoDev",
    //   description: "Este projeto foi criado para testar o funcionamento de um bot de Telegram que realiza consultas em APIs de previsão do tempo e consulta de livros e retorna os dados em um formato amigável para o usuário.",
    //   languages: [".NET8", "Worker Service", "Python", "PostgreSQL", "Docker", "Kubernetes", "API Telegram"],
    //   link: "https://t.me/zausodev_bot",
    //   deploy: true,
    // },
    {
      title: "ValidaDoc",
      description: "Este projeto visa oferecer validação OCR de documentos com alta precisão e eficiência.",
      languages: ["React", ".NET8", "Python", "Golang", "PostgreSQL", "Docker", "Kubernetes", "ELK Stack", "Microsserviços"],
      link: "https://validadoc.zauso-dev.com.br/",
      deploy: true,
    },
    {
      title: "Microservices",
      description: "Este projeto visa oferecer arquitetura de microfrontends escalável desenvolvida com React e Single-SPA. Utilizamos SystemJS para a integração dinâmica de módulos, permitindo uma estrutura distribuída, modular e de fácil manutenção.",
      languages: ["Single-SPA", "React", "SystemJS", "Python", "Golang", ".NET8", "MongoDB", "PostgreSQL", "Docker", "Kubernetes", "ELK Stack", "Backblaze"],
      link: "https://microservices.zauso-dev.com.br/",
      deploy: true,
    },
    {
      title: "RandomPass",
      description: "Esse projeto visa criar e compartilhar senhas ou textos sensíveis por meio de um link temporário.",
      languages: ["React", ".NET10", "Minimal API", "Docker", "Kubernetes", "Redis"],
      link: "https://randompass.zauso-dev.com.br/",
      deploy: true,
    },
    {
      title: "TemplatesBots",
      description: "Este projeto visa oferecer aos usuários a gestão de bots de Telegram, possibilitando a personalização de mensagens...",
      languages: [],
      link: "",
      deploy: false,
    },
    {
      title: "LibraryBooks",
      description: "Este projeto visa oferecer aos usuários a gestão de livros, possibilitando a criação de listas de leitura, acompanhamento de leitura e muito mais.",
      languages: [],
      link: "",
      deploy: false,
    }
  ];

  return (
   <div className="projects-container">
      <h1 className="text-center font-bold mb-5 text-white text-font-family">Projetos</h1>

      <div className="text-center text-color-site text-font-family">
        <p className="lead">
          Aqui você vai encontrar ideias de projetos que utilizamos de laboratório
          para testar novas tecnologias e estudar toda esteira de desenvolvimento.
        </p>
      </div>

      <div className="projects-grid">
        {projects.map((project, index) => (
          <div key={index} className="project-card">

            <h2 className="text-font-family text-color-site">
              {project.title}
            </h2>

            <div className="text-font-family text-color-site" style={{ marginBottom: 8 }}>
              <strong>Descrição do Projeto</strong>
            </div>

            <p className="project-description">{project.description}</p>

            {Array.isArray(project.languages) && project.languages.length > 0 ? (
              <button
                className="btn-collapse"
                onClick={() => openModal(project.languages)}
              >
                <FontAwesomeIcon icon={faCog} className="arrow" />
                Tecnologias utilizadas
              </button>
            ) : (
              <div className="text-collapse">
                <FontAwesomeIcon icon={faCog} className="arrow" />
                Tecnologias em definição
              </div>
            )}

            {project.deploy ? (
              <>
                <hr style={{ color: 'white' }} />
                <a
                  href={project.link}
                  target="_blank"
                  className="project-link"
                >
                  <FontAwesomeIcon icon={faGlobe} className="me-2" />
                  Visualizar projeto
                </a>
              </>
            ) : (
              <div className="text-font-family text-color-site" style={{ paddingTop: 25 }}>
                <FontAwesomeIcon icon={faHammer} className="hammer-animation me-2" />
                Em Desenvolvimento
              </div>
            )}

          </div>
        ))}
      </div>

      {modalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="mb-3">Tecnologias utilizadas</h3>
            <ul style={{ listStyle: "none", padding: 0 }}>
              {modalTechnologies.map((lang, i) => (
                <li key={i} className="d-flex align-items-center mb-2">
                  <FontAwesomeIcon icon={faCog} className="me-2" />
                  <span><i>{lang}</i></span>
                </li>
              ))}
            </ul>
            <button className="modal-close-btn" onClick={closeModal}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Projects;